// 半自动
const semiAutomatic = [
    {
        label: 'Grus 710E',
        value: 'Grus710E',
    },
    {
        label: 'Grus 710S',
        value: 'Grus710S',
    },
    {
        label: 'Grus 720E',
        value: 'Grus720E',
    },
    {
        label: 'Grus 720S',
        value: 'Grus720S',
    },
    {
        label: 'Grus 730E',
        value: 'Grus730E',
    },
    {
        label: 'Grus 730S',
        value: 'Grus730S',
    },
    {
        label: 'Grus 750M',
        value: 'Grus750M',
    },
    {
        label: 'Grus 750S',
        value: 'Grus750S',
    },
    {
        label: 'Grus 760E',
        value: 'Grus760E',
    },
    {
        label: 'Grus 760M',
        value: 'Grus760M',
    },
    {
        label: 'Grus 760S',
        value: 'Grus760S',
    },
    {
        label: 'Grus 770M',
        value: 'Grus770M',
    },
    {
        label: 'Grus 780M',
        value: 'Grus780M',
    },
    {
        label: 'Grus 790M',
        value: 'Grus790M',
    },
];

export const grusOptions = {
    grus700: semiAutomatic
}
